<template>
  <mdc-dialog  class="short-modal"
              v-model="isOpen"
              :title="'protocol.change_popup_title' | trans"
              :accept="'user.save' | trans"
              :cancel="'user.cancel' | trans"
              @validate="validate"
              @accept="accept" @cancel="cancel">
    <div class="row">
      <div class="col-12">
        <mdc-radio v-model="fixingChange" name="fixingChange" :disabled="disabledNotImportantChanges"
                   :label="'protocol.inessential' | trans" value="1"/>
      </div>
      <div class="col-12">
        <mdc-radio v-model="fixingChange" name="fixingChange" :disabled="disabledNotImportantChanges"
                   :label="'protocol.minor' | trans" value="2"/>
      </div>
      <div class="col-12">
        <mdc-radio v-model="fixingChange" name="fixingChange"
                   :label="'protocol.important' | trans" value="3"/>
      </div>
    </div>
  
    <div class="row mt-3">
      <div class="col-12">
        <h3 class="page-sub-title text-danger">{{'protocol.changes_date_text' | trans}}</h3>
        <h3 class="page-sub-title">
          {{'protocol.entered_session_date' | trans}}
        </h3>
      </div>
      <div class="col-md-6 col-12">
        <div class="datepicker datepicker__width">
          <v-date-picker
              v-model='rangeDateStart'
              v-validate="'required'"
              name="rangeDateStart"
              data-vv-validate-on="none"
              :data-vv-as="'protocol.entered_session_date' | trans"
              :formats='formats'
              :pickTime="true"
              :format="'YYYY-MM-DD HH:mm'"
              :min-date="minDateStart"
              :max-date="maxDateStart"
              title-position="left">
          </v-date-picker>
          <mdc-icon icon="date_range"></mdc-icon>
  
          <span class="invalid-feedback-label" v-if="errors.has('rangeDateStart')">
            <strong>{{ errors.first('rangeDateStart') }}</strong>
          </span>
          
        </div>
      </div>
      <div class="col-md-6 col-12 time-picker-wrapp">
        <vue-timepicker format="HH:mm" v-model='rangeTimeStart' :hour-range="[hourRange]" :minute-range="[minuteRange]" hide-clear-button></vue-timepicker>
        <span class="invalid-feedback-label" v-if="errorTime">
            <strong>{{'protocol.entered_session_date' | trans}}</strong>
          </span>
      </div>
    </div>

    <mdc-textfield v-model="comment"
                   name="comment"
                   v-validate="'required|max:500'"
                   max="500"
                   :class="{'is-invalid': errors.has('comment')}"
                   data-vv-validate-on="none"
                   :data-vv-as="'bids.comment' | trans"
                   multiline rows="4" cols="40"
                   :disabled="fixingChange == 1"
                   type="text"/>

    <span class="invalid-feedback-label" v-if="errors.has('comment')">
      <strong>{{ errors.first('comment') }}</strong>
    </span>

  </mdc-dialog>
</template>

<script>

  import VueTimepicker from 'vue2-timepicker';
  import moment from 'moment';
  import Constants from '../../undesirableBehavior/Constants';
  
  export default {
    name: 'ChangeFixingModal',
    data() {
      return {
        comment: '',
        fixingChange: '3',
        rangeDateStart: null,
        rangeTimeStart: {
          HH: '',
          mm: ''
        },
        formats: {
          title: 'MMMM YYYY',
          weekdays: 'WW',
          navMonths: 'MMM',
          input: ['DD MMM YYYY'],
          dayPopover: 'L',
          data: ['DD MMM YYYY'],
        },
        hourRange: [0, 23],
        minuteRange: [0, 60],
        maxDateStart: new Date(),
        minDateStart: null,
        errorTime: false
      }
    },
    props: {
      visible: {
        required: true,
        types: [Boolean],
      },
      client: null,
      protocol: null,
      disabledNotImportantChanges: false
    },
    computed: {
      isOpen: {
        get: function () {
          return this.visible
        },
        set: function () {},
      },
    },
    components: {VueTimepicker},
    created(){
      if (this.protocol.endDate){
        this.rangeDateStart = moment(this.protocol.endDate.date, 'YYYY-MM-DD HH:mm').toDate(); //new Date(this.toLocaleDate(this.protocol.endDate.date));

        this.minDateStart = this.rangeDateStart;
        let hours =  this.rangeDateStart.getHours();
        this.rangeTimeStart.HH = hours > 9 ? hours.toString() : '0' + hours;
        let min = this.rangeDateStart.getMinutes() + 1;
        if(min < 60){
          this.rangeTimeStart.mm =  min > 9 ? min.toString() : '0' + min;
        } else{
          this.rangeTimeStart.mm = '00';
          this.rangeTimeStart.HH = hours > 9 ? (hours+1).toString() : '0' + (hours+1);
        }


      }
    },
    
    methods: {

      toLocaleDate: function (date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('YYYY.MM.DD HH:mm');
      },

      
      accept: function () {
        let clientTimeZoneOffset = this.client.timezone ? moment().tz(this.client.timezone)._offset : 0;
        
        let fixingChangeDate = moment(new Date(Date.UTC(this.rangeDateStart.getFullYear(),
          this.rangeDateStart.getMonth(),
          this.rangeDateStart.getDate(),
          this.rangeTimeStart.HH,
          this.rangeTimeStart.mm))).unix()  - (Math.abs(clientTimeZoneOffset) * Constants.SECONDS_PER_MINUTE);

        
        this.$emit('accept', this.fixingChange, this.comment, fixingChangeDate)
      },
      cancel: function () {
        this.$emit('cancel')
      },
      async validate() {
        this.errors.clear();

        let result = await this.$validator.validateAll();
        
        if (!this.rangeTimeStart.HH || !this.rangeTimeStart.mm){
          this.errorTime = true;
          return;
        }

        if (result){
          this.accept();
        }
      }
    },
    watch: {
      rangeDateStart(newDate){
        if(moment(newDate).format('DD.MM.YYYY') === moment(this.minDateStart).format('DD.MM.YYYY')){
            let hours =  this.minDateStart.getHours();
            let min = this.minDateStart.getMinutes() + 1;
            this.hourRange = [hours, 23];
            if (this.rangeTimeStart.HH < hours){
              this.minuteRange = [min, 60];
              this.rangeTimeStart.HH = null
              this.rangeTimeStart.mm = null
            }
        } else{
          this.hourRange = [0, 23];
          this.minuteRange = [0, 60];
        }
      },
      rangeTimeStart(newTime){
        if(moment(this.rangeDateStart).format('DD.MM.YYYY') === moment(this.minDateStart).format('DD.MM.YYYY') && newTime.HH) {
          let hours =  this.minDateStart.getHours();
          let min = this.minDateStart.getMinutes() + 1;
          if (newTime.HH == hours){
            this.minuteRange = [min, 60];
            if(this.rangeTimeStart.mm < min){
              this.rangeTimeStart.mm = null
            }
          } else{
            this.minuteRange = [0, 60];
          }
        }
      }
      
    }
  }
</script>



// WEBPACK FOOTER //
// src/modules/protocols/components/ChangeFixingModal.vue